export default "__VITE_ASSET__ChBjb$vr__"